import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import ECheckbox from '@common/ui/ECheckbox/ECheckbox.vue';
import { useField } from 'vee-validate';
import { toRef } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ECheckboxField',
    props: {
        hideError: { type: Boolean, default: false },
        name: {},
        label: {},
        tabIndex: { default: 0 },
        id: {},
        hideLabel: { type: Boolean },
        disabled: { type: Boolean },
        indeterminate: { type: Boolean },
        fakeChecked: { type: Boolean },
        border: { type: Boolean },
        size: { default: 'medium' },
        theme: { default: 'primary' },
        unstyled: { type: Boolean, default: false }
    },
    emits: ["change"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var emit = __emit;
        var props = __props;
        var name = toRef(props, 'name');
        var handleChange = function (e) {
            emit('change', e);
        };
        var inputValue = useField(name, undefined, {
            syncVModel: true,
            type: 'checkbox',
        }).value;
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(ECheckbox, {
                id: _ctx.id,
                checked: _unref(inputValue),
                "onUpdate:checked": _cache[0] || (_cache[0] = function ($event) { return (_isRef(inputValue) ? (inputValue).value = $event : null); }),
                border: _ctx.border,
                disabled: _ctx.disabled,
                "fake-checked": _ctx.fakeChecked,
                "hide-error": _ctx.hideError,
                "hide-label": _ctx.hideLabel,
                indeterminate: _ctx.indeterminate,
                label: _ctx.label,
                name: name.value,
                size: _ctx.size,
                "tab-index": _ctx.tabIndex,
                theme: _ctx.theme,
                unstyled: _ctx.unstyled,
                onChange: handleChange
            }, {
                default: _withCtx(function (_a) {
                    var checked = _a.checked;
                    return [
                        _renderSlot(_ctx.$slots, "default", { checked: checked })
                    ];
                }),
                _: 3
            }, 8, ["id", "checked", "border", "disabled", "fake-checked", "hide-error", "hide-label", "indeterminate", "label", "name", "size", "tab-index", "theme", "unstyled"]));
        };
    }
});
